module.exports = __webpack_public_path__ + "img/ok.b34e79a7.svg";